import type { DefaultPlan } from 'payments/payments-dialog/lib/plans'
import { isCoinSubscriptionPlan } from 'payments/payments-dialog/lib/plans'
import { isStudioAiPricingPlan } from 'payments/studio-ai-plans'
import type { UseCase } from 'cf-types'

export const OPEN_PAYMENT_DIALOG_EVENT_NAME = 'cf_studio_open_payment_dialog'

export interface OpenPaymentsDialogEventDetail {
  plan?: string
  useCase?: string
}

const DEFAULT_PLANS = new Set<DefaultPlan>([
  'freeTrial',
  'yearly',
  'monthly',
  'freeTrialYearly',
  'aiStudio',
  'studioUnlimited',
  'teamMonthly',
])

const USE_CASES = new Set<UseCase>([
  'purchase',
  'one-click-upgrade',
  'payment-button',
  'nudge',
  'easter-promo',
  'popup-promo',
])

export function parseOpenPaymentsDialogPlan(plan: string | undefined): DefaultPlan | undefined {
  if (!plan) {
    return undefined
  }

  if (DEFAULT_PLANS.has(plan as DefaultPlan)) {
    return plan as DefaultPlan
  }

  if (isCoinSubscriptionPlan(plan) || isStudioAiPricingPlan(plan)) {
    return plan
  }

  return undefined
}

export function parseOpenPaymentsDialogUseCase(useCase: string | undefined): UseCase | undefined {
  if (!useCase || !USE_CASES.has(useCase as UseCase)) {
    return undefined
  }

  return useCase as UseCase
}

export function dispatchOpenPaymentsDialog(detail?: OpenPaymentsDialogEventDetail) {
  document.dispatchEvent(new CustomEvent(OPEN_PAYMENT_DIALOG_EVENT_NAME, { detail }))
}
